/* Ricerca e filtri dell'indice.

   Le schede sono già tutte nell'HTML: qui si nascondono, non si costruiscono.
   È la ragione per cui l'indice resta una pagina indicizzabile anche con i
   filtri attivi — Google vede l'elenco completo, il lettore vede il taglio
   che ha scelto.

   I criteri stanno negli attributi data- della scheda, scritti in Liquid dai
   metafield della pagina. Il JavaScript non interroga nulla e non chiama nulla:
   confronta stringhe.  */

(() => {
  const barra = document.querySelector('[data-filtri]');
  const griglia = document.querySelector('.indice__griglia');
  if (!barra || !griglia) return;

  const schede = [...griglia.querySelectorAll('.indice__card')];
  const campo = barra.querySelector('[data-cerca]');
  const esito = barra.querySelector('[data-esito]');
  const nessuno = document.querySelector('[data-nessuno]');
  const azzera = [...document.querySelectorAll('[data-azzera]')];

  // Accenti e maiuscole via: chi cerca "ametrino" deve trovare "Ametrino",
  // e chi cerca "occhio di tigre" non deve sapere dove cadono gli accenti.
  const piano = (s) =>
    (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();

  const attivi = { iniziale: '', chakra: '', colore: '', segno: '' };

  /*
   * La fascia alfabetica arriva dall'indirizzo, non da un pulsante.
   *
   * Seicentocinquantotto pietre non stanno in un menu, e la soluzione — la
   * stessa che usa la fonte — e' spezzarle in fasce: /pages/pietre#c-d. Il
   * filtro per iniziale singola resta come pulsante; questa e' la sua versione
   * a intervallo, e serve solo a chi arriva da un link.
   */
  const daIndirizzo = () => {
    const m = /^#([a-z])-([a-z])$/i.exec(window.location.hash || '');
    return m ? [m[1].toLowerCase(), m[2].toLowerCase()] : null;
  };
  let fascia = daIndirizzo();
  let cerca = '';

  /* La ricerca per senso.

     Sull'indice dei temi il titolo non basta: chi ha paura cerca "paura", e la
     pagina si chiama "Pietre contro l'ansia". L'indice — costruito dal testo
     delle pagine, con i sinonimi che la gente usa e i testi no — dice quanto
     ogni parola è tipica di ogni tema.

     Vale solo come secondo passaggio: se il titolo combacia, comanda il titolo.
     Cercare "sonno" deve dare prima la pagina del sonno, non le dodici che ne
     parlano. */
  // Si legge al momento dell'uso, non qui: i due script sono differiti e
  // partono in ordine di dichiarazione, quindi quando questo file gira
  // ricerca-temi.js non ha ancora scritto niente. Catturarlo adesso significa
  // catturare il vuoto.
  function pertinenza(handle, query) {
    const concetti = window.RICERCA_TEMI;
    if (!concetti || !concetti[handle]) return 0;
    const suo = concetti[handle];
    // la frase intera pesa più della somma delle sue parole: "mal di testa"
    // deve vincere su una pagina che nomina "testa" per caso
    let punti = (suo[query] ?? 0) * 2;
    for (const parola of query.split(/\s+/)) {
      if (parola.length < 3) continue;
      punti += suo[parola] ?? 0;
      // "insonnie" trova "insonnia": si accetta anche il prefisso, ma vale meno
      if (!suo[parola]) {
        for (const chiave in suo) {
          if (chiave.length > 4 && (chiave.startsWith(parola) || parola.startsWith(chiave))) {
            punti += suo[chiave] * 0.5;
            break;
          }
        }
      }
    }
    return punti;
  }

  function applica() {
    let visibili = 0;

    // si guarda una volta sola se qualche titolo combacia: se nessuno lo fa,
    // entra in gioco il senso
    const perNome = cerca
      ? schede.some((s) => piano(s.dataset.nome).includes(cerca))
      : true;

    for (const scheda of schede) {
      let ok = true;

      if (cerca && !piano(scheda.dataset.nome).includes(cerca)) {
        const punti = perNome ? 0 : pertinenza(scheda.dataset.handle, cerca);
        if (punti > 0) scheda.style.order = String(Math.round(1000 - punti * 10));
        else ok = false;
      } else if (cerca) {
        scheda.style.order = '0';
      } else {
        scheda.style.order = '';
      }

      if (ok && attivi.iniziale && scheda.dataset.iniziale !== attivi.iniziale) ok = false;

      if (ok && fascia) {
        const i = (scheda.dataset.iniziale || '').toLowerCase();
        if (i < fascia[0] || i > fascia[1]) ok = false;
      }

      for (const chiave of ['chakra', 'colore', 'segno']) {
        if (!ok || !attivi[chiave]) continue;
        // il valore è una lista separata da barre: si confronta voce per voce,
        // altrimenti "Rosso" combacerebbe dentro "Rosso scuro"
        const valori = (scheda.dataset[chiave] || '').split('|');
        if (!valori.includes(attivi[chiave])) ok = false;
      }

      scheda.hidden = !ok;
      if (ok) visibili++;
    }

    const filtrato = cerca !== '' || Boolean(fascia) || Object.values(attivi).some(Boolean);

    if (esito) {
      esito.textContent = filtrato
        ? `${visibili} ${visibili === 1 ? 'scheda' : 'schede'} su ${schede.length}`
        : '';
    }
    if (nessuno) nessuno.hidden = visibili !== 0;
    griglia.hidden = visibili === 0;
    for (const b of azzera) b.hidden = !filtrato;
  }

  campo?.addEventListener('input', () => {
    cerca = piano(campo.value);
    applica();
  });

  for (const pulsante of barra.querySelectorAll('[data-filtro]')) {
    pulsante.addEventListener('click', () => {
      const chiave = pulsante.dataset.filtro;
      const valore = pulsante.dataset.valore;

      // ricliccare il filtro attivo lo toglie: è più rapido che cercare "Tutti"
      attivi[chiave] = attivi[chiave] === valore ? '' : valore;

      for (const altro of barra.querySelectorAll(`[data-filtro="${chiave}"]`)) {
        const acceso = altro.dataset.valore === attivi[chiave];
        altro.classList.toggle('is-attivo', acceso);
        altro.setAttribute('aria-pressed', acceso ? 'true' : 'false');
      }
      applica();
    });
  }

  for (const b of azzera) {
    b.addEventListener('click', () => {
      cerca = '';
      if (campo) campo.value = '';
      fascia = null;
      if (window.location.hash) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
      for (const k of Object.keys(attivi)) attivi[k] = '';
      for (const p of barra.querySelectorAll('[data-filtro]')) {
        const acceso = p.dataset.valore === '';
        p.classList.toggle('is-attivo', acceso);
        p.setAttribute('aria-pressed', acceso ? 'true' : 'false');
      }
      applica();
      campo?.focus();
    });
  }

  window.addEventListener('hashchange', () => { fascia = daIndirizzo(); applica(); });

  applica();
})();
